import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function FeaturedComics() {
  const featured = comics.filter((c) => c.featured);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">编辑精选，品质保证</p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
          {featured.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group block"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3">
                <img
                  src={comic.cover}
                  alt={`${comic.title}漫画封面`}
                  title={`${comic.title} - 073漫画网`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-[10px] font-medium">
                    {comic.rating}分
                  </span>
                </div>
                {comic.status === '连载中' && (
                  <div className="absolute top-2 right-2">
                    <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-[10px] font-medium">
                      连载中
                    </span>
                  </div>
                )}
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}